import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const useI18nReady = () => {
    const { i18n, ready } = useTranslation();
    const [isI18nReady, setI18nReady] = useState(false);

    useEffect(() => {
        if (ready) {
            setI18nReady(true);
        } else {
            const handleI18nLanguageChanged = () => {
                setI18nReady(i18n.hasResourceBundle(i18n.language, 'translation'));
            };

            i18n.on('languageChanged', handleI18nLanguageChanged);

            return () => {
                // Cleanup listener on unmount
                i18n.off('languageChanged', handleI18nLanguageChanged);
            };
        }
        return () => undefined;
    }, [i18n, ready]);

    return isI18nReady;
};

export default useI18nReady;
